// extracted by mini-css-extract-plugin
export default {"root":"logo_root__oz289","rootNotLink":"logo_rootNotLink__XQ3QC logo_root__oz289"};